
import React, { useState, useEffect } from 'react'
import "../../css/GallerySample.css"
import * as Requests from "../../library/requests/Requests"
import { Gallery } from "../../library/Gallery"
import Upload from "../../library/Upload"

interface GallerySampleProps {
  gallery: Gallery
}

function GallerySample({ gallery }: GallerySampleProps) {
  const [uploads, setUploads] = useState<Upload[]>([])
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!gallery.latestUploadsUrl) {
      return
    }

    Requests.getJson(gallery.latestUploadsUrl,
      (json: any) => {
        setUploads(json._embedded.uploads)
      },
      (error: string) => {
        setError(error)
      })
  }, [gallery.latestUploadsUrl, setUploads, setError])

  if (uploads == null || uploads.length < 6 || error) {
    return <></>
  }

  return (
    <>
      <div id="gallerySample">
        <div>
          <img src={uploads[0].media.thumbnail} alt="" />
          <img src={uploads[1].media.medium} alt="" />
          <img src={uploads[2].media.thumbnail} alt="" />
        </div>
        <div>
          <img src={uploads[3].media.thumbnail} alt="" />
          <img src={uploads[4].media.thumbnail} alt="" />
          <img src={uploads[5].media.thumbnail} alt="" />
        </div>
      </div>
      <div className="clearfix" style={{ paddingBottom: "30px" }}></div>
    </>
  )
}

export default GallerySample
